/** Anonymous aggregate events only: never pass filenames, file contents, or input values. */
export const telemetryToolIds = ['barcode', 'images-to-pdf', 'merge-pdf', 'pdf-editor', 'pdf-prepare-form', 'image-filter', 'get-paths', 'images-to-gif', 'video-to-gif', 'image-converter', 'image-resize', 'ai-image-upscaler', 'prompt-builder'] as const;
export type TelemetryToolId = typeof telemetryToolIds[number];
export type UsageEvent = { id: string; toolId: TelemetryToolId; action: 'start' | 'success' | 'export'; operationId: string; bytes?: number };
export function canCollectUsage(location: { protocol: string; hostname: string }) {
  return location.protocol === 'https:' && ['designforge.site', 'designforge-8km.pages.dev'].includes(location.hostname);
}
export function startOperation(toolId: TelemetryToolId) {
  let complete = false;
  let queue = Promise.resolve();
  const enabled = typeof window !== 'undefined' && canCollectUsage(window.location) && telemetryToolIds.includes(toolId) && typeof crypto?.randomUUID === 'function';
  let operationId = '';
  try { if (enabled) operationId = crypto.randomUUID(); } catch { /* Unsupported clients remain usable. */ }
  const send = (action: UsageEvent['action'], bytes?: number) => {
    if (!enabled || !operationId) return;
    let id: string;
    try { id = crypto.randomUUID(); } catch { return; }
    const event: UsageEvent = { id, toolId, action, operationId };
    if (bytes !== undefined && Number.isSafeInteger(bytes) && bytes >= 0) event.bytes = bytes;
    queue = queue.then(async () => {
      try { await fetch('/api/events', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(event), credentials: 'same-origin', keepalive: true }); } catch { /* Analytics never interrupts local processing. */ }
    });
  };
  send('start');
  return { complete(options: { exportBytes?: number } = {}) {
    if (complete) return;
    complete = true;
    send('success');
    if (options.exportBytes !== undefined && Number.isSafeInteger(options.exportBytes) && options.exportBytes >= 0) send('export', options.exportBytes);
  } };
}
